import React from 'react';
import { usePlayerContext } from '../_contexts/player-context';
import styles from './player-loading.module.scss';

interface Props {
  playerWaiting: boolean;
  playerIsClosing: boolean;
}

export const PlayerLoadingBackground: React.FC<Props> = (props: Props) => {
  const { playerWaiting, playerIsClosing } = props;

  const { firstTimeLoading } = usePlayerContext();

  if (!firstTimeLoading && !playerWaiting && !playerIsClosing) return null;

  return <div className={styles['player-loading__background']} />;
};

export default React.memo(PlayerLoadingBackground);
